import api from './api'

const websiteContactService = {
  getWebsiteContacts: ({ search = '', skipCount = 0, totalCount = 10 }) =>
    api.get('/api/WebsiteContacts', {
      params: {
        Search: search,
        SkipCount: skipCount,
        TotalCount: totalCount
      }
    })
}

export default websiteContactService
